import { useContext, createContext } from 'react';

import { ZoomChangeType } from '../../../core/types/zoom.js';

export type DisplayConfigProps = {
  highlightedSeriesIds?: string[];
  zoomChangeType?: ZoomChangeType;
};

export const DisplayConfigContext = createContext<DisplayConfigProps>({});

/**
 * Whenever the component is rendered as wrapped within a `DisplayConfigContext` provider, the hook will
 * return the context values for the properties in `DisplayConfigProps` defined on a context level. Otherwise
 * the default property values that are passed to the hook are used.
 * If the component is NOT rendered within a `DisplayConfigContext` provider, the hook will return these fallback props as default.
 * @see {@link DisplayConfigContext}
 * @see {@link DisplayConfigProps}
 */
export function useDisplayConfigContext(): DisplayConfigProps {
  return useContext(DisplayConfigContext);
}

DisplayConfigContext['displayName'] = 'DisplayConfigContext';
